import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { WorkDayTypesForm } from '@modules/hr-workDayTypes/WorkDayTypesForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const workDayTypesUrl = '/metropolis/api/hr/workplan/evidence/types';
export const workDayTypesLabel = 'Typ pracovního dne';
export const workDayTypesPath = '/hr/work-day-types';
export const workDayTypesGridName = 'work-day-types-form';
export const WorkDayTypesGrid = compose(
  withRouter,
  setDisplayName('WorkDayTypesGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: workDayTypesLabel }]),
  withColumns(Agenda.WORK_DAY_TYPES),
  withProps(({ columns }) => ({
    name: workDayTypesGridName,
    url: workDayTypesUrl,
    Form: WorkDayTypesForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.WORK_DAY_TYPES} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-workDayTypes/WorkDayTypesGrid.tsx